import { Component, OnInit } from '@angular/core';
import { TrackerService } from 'src/app/shared/util/tracker.service';

interface CareerPosition {
  titleKey: string;
  descKey: string;
}

interface CareerBenefit {
  icon: string;
  titleKey: string;
  descKey: string;
}

@Component({
  selector: 'app-footer-careers',
  templateUrl: './footer-careers.component.html',
  styleUrls: ['./footer-careers.component.scss'],
})
export class FooterCareersComponent implements OnInit {
  readonly careersEmail = 'careers@propero.io';
  readonly careersMailto = `mailto:${this.careersEmail}`;

  readonly whyJoinKeys = [
    'FOOTER.CAREERS_WHY_JOIN_1',
    'FOOTER.CAREERS_WHY_JOIN_2',
    'FOOTER.CAREERS_WHY_JOIN_3',
    'FOOTER.CAREERS_WHY_JOIN_4',
  ];

  readonly positions: CareerPosition[] = [
    { titleKey: 'FOOTER.CAREERS_POSITION_1_TITLE', descKey: 'FOOTER.CAREERS_POSITION_1_DESC' },
    { titleKey: 'FOOTER.CAREERS_POSITION_2_TITLE', descKey: 'FOOTER.CAREERS_POSITION_2_DESC' },
    { titleKey: 'FOOTER.CAREERS_POSITION_3_TITLE', descKey: 'FOOTER.CAREERS_POSITION_3_DESC' },
    { titleKey: 'FOOTER.CAREERS_POSITION_4_TITLE', descKey: 'FOOTER.CAREERS_POSITION_4_DESC' },
  ];

  readonly benefits: CareerBenefit[] = [
    {
      icon: 'lni-hourglass',
      titleKey: 'FOOTER.CAREERS_BENEFIT_1_TITLE',
      descKey: 'FOOTER.CAREERS_BENEFIT_1_DESC',
    },
    {
      icon: 'lni-timer',
      titleKey: 'FOOTER.CAREERS_BENEFIT_2_TITLE',
      descKey: 'FOOTER.CAREERS_BENEFIT_2_DESC',
    },
    {
      icon: 'lni-graduation',
      titleKey: 'FOOTER.CAREERS_BENEFIT_3_TITLE',
      descKey: 'FOOTER.CAREERS_BENEFIT_3_DESC',
    },
    {
      icon: 'lni-home',
      titleKey: 'FOOTER.CAREERS_BENEFIT_4_TITLE',
      descKey: 'FOOTER.CAREERS_BENEFIT_4_DESC',
    },
  ];

  constructor(private trackerService: TrackerService) {}

  ngOnInit(): void {
    this.trackerService.trackPageViews();
  }
}
